import React from 'react';
import { TrendingDown, ShieldAlert } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function ProofSection() {
  return <section className="py-24 md:py-32 bg-navy text-white relative overflow-hidden" data-id="element-229">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#FAFAF7 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} data-id="element-230"></div>

      <div className="container mx-auto px-4 md:px-6 max-w-5xl relative z-10" data-id="element-231">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-232">
          <FadeIn data-id="element-233">
            <div data-id="element-234">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 text-amber text-sm font-medium mb-8 border border-white/20" data-id="element-235">
                <ShieldAlert size={16} data-id="element-236" />
                <span data-id="element-237">Resultados Comprobados</span>
              </div>

              <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold mb-6 leading-tight" data-id="element-238">
                El poder de quitarles el{' '}
                <span className="text-amber" data-id="element-239">combustible</span>
              </h2>

              <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-8" data-id="element-240">
                En los primeros 7 días de aplicación del método, la mayoría de
                los niños reportan un descenso drástico en la intensidad del
                acoso al dejar de proporcionar la "reacción emocional" que los
                agresores necesitan para alimentar su ego.
              </p>
            </div>
          </FadeIn>

          <FadeIn direction="left" delay={0.2} data-id="element-241">
            <div className="bg-white/5 border border-white/10 p-8 md:p-12 rounded-3xl backdrop-blur-md relative overflow-hidden" data-id="element-242">
              <div className="absolute -top-24 -right-24 w-48 h-48 bg-teal rounded-full blur-3xl opacity-30" data-id="element-243"></div>
              <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-amber rounded-full blur-3xl opacity-20" data-id="element-244"></div>

              <div className="relative z-10 flex flex-col items-center text-center" data-id="element-245">
                <div className="w-20 h-20 rounded-full bg-teal/20 flex items-center justify-center text-teal-light mb-6" data-id="element-246">
                  <TrendingDown size={40} className="stroke-[2.5]" data-id="element-247" />
                </div>

                <div className="text-7xl md:text-8xl font-bold text-white mb-4 tracking-tighter" data-id="element-248">
                  60<span className="text-amber" data-id="element-249">%</span>
                </div>

                <h3 className="text-2xl font-bold text-white mb-2" data-id="element-250">
                  Reducción del Acoso
                </h3>
                <p className="text-gray-400" data-id="element-251">
                  En los primeros 7 días de aplicación
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}